/** Prompt-Limit einer Auswertung (identisch zur Backend-Validierung). */
export const PROMPT_MAX_LENGTH = 10000;

/** Formularzustand beim Bearbeiten einer Standard-Auswertung. */
export interface CriterionFormState {
  name: string;
  prompt: string;
  categories: string[];
  isActive: boolean;
}

/** Feldfehler des Formulars; leer = gültig. */
export interface CriterionFormErrors {
  name?: string;
  prompt?: string;
  categories?: string;
}

/**
 * Validiert das Formular wie das Backend: Bezeichnung Pflicht, Prompt Pflicht
 * und max. 10.000 Zeichen, mindestens 2 Kategorien.
 */
export function validateCriterionForm(form: CriterionFormState): CriterionFormErrors {
  const errors: CriterionFormErrors = {};
  if (!form.name.trim()) errors.name = 'Bitte eine Bezeichnung vergeben.';
  if (!form.prompt.trim()) errors.prompt = 'Bitte einen Prompt angeben.';
  else if (form.prompt.length > PROMPT_MAX_LENGTH) errors.prompt = `Maximal ${PROMPT_MAX_LENGTH.toLocaleString('de-DE')} Zeichen.`;
  if (form.categories.length < 2) errors.categories = 'Bitte mindestens 2 Kategorien angeben.';
  return errors;
}
